import {
    IOrderFilters,
    IOrderSummary,
    OrderFilters,
    OrderService,
} from '../../../tn.common';
import template from './accountOrdersPage.html';

type Sort = 'paymentType' | 'created' | 'licensee_first_name' | 'id';

export class AccountOrdersPageController {
    // complete list of all summaries
    allSummaries?: IOrderSummary[];
    // indicates there is an inflight call to load or updatepdate allSummaries when true.
    allSummariesLoading = true;

    // filtered set of summaries
    filteredSummaries?: IOrderSummary[];
    // indicates there is an inflight call to update filteredSummaries
    filteredSummariesLoading = true;

    orders: IOrderSummary[] = [];
    predicate = 'created';
    reverse = true;
    caretClass = 'icon-caret-down';

    static $inject = ['orderService', 'accountOrderFilters'];
    constructor(
        protected orderService: OrderService,
        protected filters$: OrderFilters
    ) {}

    $onInit(): void {
        // begin getting all orders so we can satisfy noloading sooner rather than later
        this.loadAllSummaries();

        // subscribe to the filters, this will immediately fire and call applyFilters
        // to apply and existing filters to the displayed list.
        this.filters$.subscribe((filters) => {
            // this
            this.applyFilters(filters);
        });
    }

    // load/reload all summaer data.
    loadAllSummaries(): void {
        this.allSummariesLoading = true;
        this.orderService.getSummaryOrders({}).then((summaries) => {
            this.allSummaries = summaries;
            this.allSummariesLoading = false;
        });
    }

    // reload the list of orders with filters applied. orderService caches the summaries
    // and individual orders and the filtering is done client side so the getSummaryOrder
    // calls are not expensive.
    applyFilters(filters: IOrderFilters = {}): void {
        this.filteredSummariesLoading = true;
        this.orderService
            .getSummaryOrders(filters)
            .then((filteredSummaries) => {
                this.filteredSummaries = filteredSummaries;
                this.filteredSummariesLoading = false;
            })
            .catch((reason) => {
                console.error('failed to load orders', reason);
            });
    }

    setSort(predicate: Sort): void {
        this.reverse =
            this.predicate === predicate ? !this.reverse : this.reverse;
        this.predicate = predicate;
        this.caretClass = this.reverse ? 'icon-caret-down' : 'icon-caret-up';
    }
}

export const accountOrdersPageComponentOptions = {
    controller: AccountOrdersPageController,
    template,
};
